"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TimePicker["default"];
  }
});

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/rc-time-picker/lib/index.js
// module id = 1639
// module chunks = 0